import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import {AppContext} from "./AppContext";

const ProtectedRoute = ({ children }) => {
    const { userId, loadingSession } = useContext(AppContext);
    
    if (loadingSession) return null; // Or a loading spinner if you prefer
    
    return userId ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
